import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const StyledHeaderLink = styled(NavLink)`
    display: flex;
    color: ${({ theme }) => theme.primaryTypographyColor};
    font-size: 16px;

    &[aria-current="page"] {
        color: ${({ theme }) => theme.additionalTypographyColor};
    }
`;
